<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn } from 'devextreme-vue/data-grid';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            AdminGrid,
            DxColumn
        },
        data() {
            return {
                filter: '',
                isLoading: 0,
                result: []
            };
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            select(freshbooksId) {
                if (this.modalData && this.modalData.onSelect) this.modalData.onSelect(freshbooksId);

                this.close();
            },
            searchCompanies() {
                const searchText = this.filter || '';

                if (searchText.length < 3) return;

                const url = `companies/freshbooks-clients/search?filter=${searchText}`;

                this.isLoading++;

                httpService
                    .get(url)
                    .then(data => {
                        this.result = data;
                    })
                    .finally(() => this.isLoading--);
            }
        }
    };
</script>

<template>
    <Modal sizeClass="modal-lg">
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Search Freshbooks Companies</h3>
                </div>
                <div class="modal-body">
                    <div class="row mb-3">
                        <div class="col-sm">
                            <input
                                type="text"
                                v-model="filter"
                                class="form-control form-control-sm"
                                required
                                placeholder="search company..."
                                @input="searchCompanies"
                            />
                        </div>
                    </div>
                    <div v-if="isLoading > 0">Searching...</div>
                    <AdminGrid
                        v-if="isLoading == 0"
                        :data-source="result"
                        :showActions="true"
                        :showFilters="false"
                        :showExport="false"
                        :showToolbar="false"
                        storage-key="resultGrid"
                    >
                        <DxColumn data-field="id" />
                        <DxColumn data-field="organization" />
                        <DxColumn data-field="name" />
                        <DxColumn data-field="lastName" caption="Last Name" />
                        <DxColumn data-field="email" />
                        <template #actions="{ item }">
                            <button type="button" class="btn btn-link py-0 lh-1 text-primary" @click="select(item.data.id)">
                                Set Freshbooks Id
                            </button>
                        </template>
                    </AdminGrid>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                </div>
            </div>
        </form>
    </Modal>
</template>
